'use strict';
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.matcher` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
defineWellKnownSymbol('matcher');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/esnext.symbol.matcher.js
// module id = 1523
// module chunks = 0